import { Divider, Skeleton, SkeletonItem, TableCell, TableRow } from '@fluentui/react-components';
import { Fragment } from 'react';
import { useSharedStyles } from '../shared-styles.js';
import type { FieldTableProps, FieldValueRecord } from '../types.js';

type FieldTableLoadingProps<TValue extends Array<FieldValueRecord>> = {
    tableCells: FieldTableProps<TValue>['tableCells'];
};

export function FieldTableLoading<TValue extends Array<FieldValueRecord>>({
    tableCells,
}: FieldTableLoadingProps<TValue>) {
    const sharedStyles = useSharedStyles();

    return Array.from({ length: 10 }, (_, valueIndex) => (
        <Fragment key={valueIndex}>
            <TableRow className={sharedStyles.tableDisplayContents}>
                <TableCell className={sharedStyles.tableDisplayContents}>
                    <Divider className={sharedStyles.tableDivider} />
                </TableCell>
            </TableRow>

            <TableRow className={sharedStyles.tableDisplayContents}>
                {tableCells.map((_, cellIndex) => (
                    <TableCell key={cellIndex} className={sharedStyles.tableCell}>
                        <Skeleton className={sharedStyles.tableCellSkeleton}>
                            <SkeletonItem className={sharedStyles.tableCellSkeletonItem} />
                        </Skeleton>
                    </TableCell>
                ))}
            </TableRow>
        </Fragment>
    ));
}
